import {useContext} from 'preact/hooks';
import {LoadingContext} from './LoadingContext.jsx';

export function LoadingBar() {
    const {loading} = useContext(LoadingContext);
    if (!loading) return null;
    return (
        <div className="fixed top-0 left-0 w-full h-0.5 bg-[linear-gradient(120deg,#7f1d1d_25%,#ef4444_50%,#7f1d1d_75%)] bg-[length:200%_100%] animate-[stripe_1.6s_linear_infinite] z-50"></div>
    );
}